import { __awaiter, __generator } from "tslib";
import { getFileTypeNameFromType, getReferralFromFileLocation, isConsumerDocument, } from '@office-start/file-utility';
import { logGenericEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { fetchMruConfig } from '@office-start/mru-config-service';
import { openShareControl, } from '@office-start/share-controls';
import { ShareControlMode } from '@office-start/share-types';
import { fetchUserEntitlements } from '@office-start/user-entitlements-service';
function getCommonInstrumentationParams(item, index) {
    var params = {};
    params["Index" /* InstrumentationParam.Index */] = index.toString();
    params["DocumentType" /* InstrumentationParam.DocumentType */] = getFileTypeNameFromType(item.fileType);
    params["ShareControlMode" /* InstrumentationParam.ShareControlMode */] =
        ShareControlMode.Share.toString();
    var storageType = getReferralFromFileLocation(item.url) || '';
    if (!storageType && isConsumerDocument(item.url)) {
        storageType = 'Consumer';
    }
    else if (storageType === "Documents" /* KnownWorkloadReferralNames.OneDrive */) {
        // TODO: Use a better enum instead of AccessTokenConsumer
        storageType = 'OneDrive';
    }
    else if (storageType === "Sites" /* KnownWorkloadReferralNames.SharePoint */) {
        storageType = 'SharePoint';
    }
    params["StorageType" /* InstrumentationParam.StorageType */] = storageType;
    // TODO?: params[InstrumentationParam.FileFormat] = MruFileFormat[this.file.format];
    return params;
}
// TODO: Share control instrumentation for clicks, impressions, etc.
export function createShareAction(item, index, componentContext, identity, targetElementId, isDarkMode, shareControlMode) {
    var _this = this;
    if (shareControlMode === void 0) { shareControlMode = ShareControlMode.Share; }
    if (item.isEmailAttachment) {
        return undefined;
    }
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var mruConfig, userEntitlements, shareItem, shareControlProps, itemElement;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchMruConfig()];
                case 1:
                    mruConfig = _a.sent();
                    return [4 /*yield*/, fetchUserEntitlements()];
                case 2:
                    userEntitlements = (_a.sent()).result;
                    shareItem = {
                        url: item.url,
                        name: item.fileName || '',
                        siteUrl: item.sharepointIds ? item.sharepointIds.siteUrl : '',
                        type: 'Commercial',
                        listItemUniqueId: item.sharepointIds
                            ? item.sharepointIds.listItemUniqueId
                            : '',
                    };
                    shareControlProps = {
                        item: shareItem,
                        fetchAccessToken: componentContext.getAccessToken,
                        shareApiUrl: (mruConfig === null || mruConfig === void 0 ? void 0 : mruConfig.shareApiEndpoint) || '',
                        market: componentContext.preferredCulture,
                        isMsa: identity.isMsa,
                        tenantId: identity.tenantId,
                        mode: shareControlMode,
                        organizationName: (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.CompanyDisplayName) || '',
                        correlationId: componentContext.correlationId,
                        shareUIPosition: (componentContext === null || componentContext === void 0 ? void 0 : componentContext.workload) == 'officehomereact'
                            ? 'absolute'
                            : 'fixed',
                        onError: function (error) {
                            var params = getCommonInstrumentationParams(item, index);
                            params["Error" /* InstrumentationParam.Error */] = error;
                            // TODO: missing errorCategory - params[InstrumentationParam.ItemCategory] = errorCategory;
                            logGenericEvent(KnownInstrumentationEvents.ShareControlError, params);
                        },
                        darkMode: isDarkMode,
                    };
                    itemElement = document.getElementById(targetElementId);
                    if (itemElement) {
                        openShareControl(shareControlProps, itemElement);
                    }
                    else {
                        // TODO: Handle error condition where itemElement is not found
                    }
                    return [2 /*return*/];
            }
        });
    }); };
}
//# sourceMappingURL=createShareAction.js.map